// Dates and times on the Sotravel Club surfaces (club page, event page,
// dashboard), in the reader's language. English patterns stay as they were;
// Chinese uses Chinese order and names ("10月20日 星期二", "晚上 6:00").
//
// The rest of the site formats with the global dayjs locale, which has no
// Traditional Chinese mapping (src/i18n.js), so club pages format explicitly
// here instead of changing every page's dates.
import dayjs from "dayjs";
import "dayjs/locale/zh-tw";
import "dayjs/locale/zh-cn";
import i18n from "../i18n";

const DAYJS_LOCALE = { "zh-Hant-TW": "zh-tw", "zh-Hans-CN": "zh-cn" };

const PATTERNS = {
  en: {
    short: "ddd, D MMM", // Tue, 20 Oct
    shortYear: "ddd, D MMM YYYY",
    long: "dddd, D MMMM", // Tuesday, 20 October
    monthDay: "MMM D", // Oct 20
    dayMonthYear: "D MMM YYYY",
    dayMonth: "D MMM", // 20 Oct
    weekday: "dddd",
    month: "MMM",
    day: "D",
    time: "h:mm A",
  },
  zh: {
    short: "M月D日（dd）", // 10月20日（二）
    shortYear: "YYYY年M月D日（dd）",
    long: "M月D日 dddd", // 10月20日 星期二
    monthDay: "M月D日",
    dayMonthYear: "YYYY年M月D日",
    dayMonth: "M月D日",
    weekday: "dddd",
    month: "M月",
    day: "D",
    time: "A h:mm", // 晚上 6:00
  },
};

const current = () => {
  const lang = i18n.language || "en";
  const locale = DAYJS_LOCALE[lang];
  return locale ? { locale, patterns: PATTERNS.zh } : { locale: "en", patterns: PATTERNS.en };
};

// clubDate("2026-10-20", "long") → "Tuesday, 20 October" / "10月20日 星期二"
export const clubDate = (value, kind = "short") => {
  if (!value) return "";
  const { locale, patterns } = current();
  return dayjs(value).locale(locale).format(patterns[kind] || kind);
};

// clubTime("18:00") → "6:00 PM" / "晚上 6:00"; minutes are added to the time.
export const clubTime = (hhmm, addMinutes = 0) => {
  if (!hhmm) return "";
  const [hh, mm] = String(hhmm).split(":").map((x) => parseInt(x, 10));
  if (!Number.isFinite(hh)) return "";
  const { locale, patterns } = current();
  return dayjs().startOf("day").hour(hh).minute(mm || 0).add(addMinutes, "minute").locale(locale).format(patterns.time);
};

// A dayjs value (already built) → the club pattern for `kind`.
export const clubFormat = (d, kind) => {
  const { locale, patterns } = current();
  return dayjs(d).locale(locale).format(patterns[kind] || kind);
};
